var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"book"},[_c('h1',[_vm._v("This is the book an appointment page")]),_c('br'),_c('br'),_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/logo.png")}})])
}]

export { render, staticRenderFns }